import { DataSecurityDetectedApp } from '@types';

import { createGetEndpoint, makeAbortableEndpoint } from '@sonar-software/sonar-http';

export type GetDataSecurityDetectedApplicationByIdRequest = {
	applicationId: number;
};

export const getDataSecurityDetectedApplicationById = makeAbortableEndpoint(
	createGetEndpoint<
		GetDataSecurityDetectedApplicationByIdRequest,
		DataSecurityDetectedApp
	>(({ applicationId }) => `/api/v3/data-security/applications/${applicationId}/detected-application-card`)
);
